<template>
  <div class="container">
    <!--header-->
    <div class="header clearfix">
      <div class="login-box">
        <span class="nav-sp">
          <img src="../../assets/images/logo1.jpg" alt="">
          <span>四川广智华荣工程项目咨询有限公司</span>
          <em class="em2">Sichuan Guangzhi Huarong Project Consulting Co., Ltd</em>
          <em>规范，专业，服务，创新</em>
        </span>
        <p class="login-iphone">
          <span class="iphone-sp1">咨询电话：</span>
          <span class="iphone-sp2">028-61894045</span>
        </p>

      </div>
      <div class="nav">
        <p class="nav-p">
          <a href="javascript:;" class="a-hover" @click="goHome()"><span>官方首页</span> </a>
          <a href="javascript:;" @click="goqyjj()"><span>企业简介</span></a>
          <a href="javascript:;" @click="gozbxx()"><span>招标信息</span></a>
          <a href="javascript:;" @click="gokffw()"><span>客服服务</span></a>
          <a href="javascript:;" @click="gogsdt()"><span>公司动态</span></a>
          <a href="javascript:;" @click="gojlyd()"><span>交流园地</span></a>
          <a href="javascript:;" @click="gorczp()"><span>人才招聘</span></a>
          <a href="javascript:;" @click="gobsxt()"><span>报名系统</span></a>
        </p>
      </div>
    </div>
    <!--header  END-->

    <!--switch-->
    <div class="switch clearfix">
      <div class="block">
        <el-carousel>
          <el-carousel-item v-for="(imgdata1,index) in imgdata" :key="index">
            <p class="small"> <img :src="imgdata1.adv_code" alt=""></p>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!--switch END-->

    <!--center-->
    <div class="center">
      <div class="gsdt">
        <h4> 公司<span>动态</span></h4>
        <div class="news-img">
          <img :src="indeximg" alt="" />
          <p v-if="newdata!==''">{{newdata.dynamic_title}}</p>
        </div>
      </div>
      <div class="news">
        <p class="news-p"  @click="gogsdt()">更多+</p>
        <template>
          <el-tabs @tab-click="handleClick" v-model="activeName">
            <el-tab-pane label="新闻资讯" name="first">
              <ul class="news-ul" >
                <li v-for="(newdata,index) in newdata1" :key="index">
                  <span class="news-span" @click="gonewstxt(newdata.dynamic_id)">{{newdata.dynamic_title}}</span><em>{{newdata.create_time}}</em>
                </li>
              </ul>

            </el-tab-pane>
            <el-tab-pane label="社会责任" name="second">
              <ul class="news-ul">
                <li v-for="(newdata,index) in newdata2" :key="index">
                  <span class="news-span" @click="gonewstxt(newdata.dynamic_id)">{{newdata.dynamic_title}}</span><em>{{newdata.create_time}}</em>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="主题活动" name="third">
              <ul class="news-ul">
                <li v-for="(newdata,index) in newdata3" :key="index">
                  <span class="news-span" @click="gonewstxt(newdata.dynamic_id)">{{newdata.dynamic_title}}</span><em>{{newdata.create_time}}</em>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="自媒体" name="fourth">
              <ul class="news-ul">
                <li v-for="(newdata,index) in newdata4" :key="index">
                  <span class="news-span" @click="gonewstxt(newdata.dynamic_id)">{{newdata.dynamic_title}}</span><em>{{newdata.create_time}}</em>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </template>

      </div>
    </div>
    <div class="center2">
      <div class="zbxx">
        <h4>招标<span>信息</span></h4><span class="zbxx-p" @click="gozbxx()">更多+</span>
        <template>
          <el-tabs @tab-click="handleClick2" v-model="activeName2">
            <el-tab-pane label="全部公告" name="negg">
              <ul class="zbxx-ul">
               <li v-for="(biaodata,index) in biaodata1" :key="index">
                 <span class="zbxx-span" @click="gozbxxtxt(biaodata.bidding_id)">{{biaodata.bidding_title}}</span><em>{{biaodata.create_time}}</em>
               </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="结果公告" name="jggg">
              <ul class="zbxx-ul">
               <li v-for="(biaodata,index) in biaodata2" :key="index">
                 <span class="zbxx-span" @click="gozbxxtxt(biaodata.bidding_id)">{{biaodata.bidding_title}}</span><em>{{biaodata.create_time}}</em>
               </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="更正公告" name="gzgg">
              <ul class="zbxx-ul">
               <li v-for="(biaodata,index) in biaodata3" :key="index">
                 <span class="zbxx-span" @click="gozbxxtxt(biaodata.bidding_id)">{{biaodata.bidding_title}}</span><em>{{biaodata.create_time}}</em>
               </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <div class="bspt">
        <h4>办事<span>平台</span></h4>
        <p class="p1" ><img src="../../assets/images/banner1.jpg" alt=""></p>
        <p class="p11" @click="gobsxt()"><img src="../../assets/images/banner2.jpg" alt=""></p>
        <p class="p2" @click="gozbxz()"><img src="../../assets/images/banner3.jpg" alt=""></p>
        <p class="p2" @click="gozbxz()"><img src="../../assets/images/banner4.jpg" alt=""></p>

      </div>
    </div>
    <div class="banner">
      <img src="../../assets/images/banner.jpg" alt="">
    </div>
    <div class="center3">
      <div class="jlyd">
        <h4>交流<span>园地</span></h4><span class="jlyd-p">更多+</span>
        <template>
          <el-tabs @tab-click="handleClick3" v-model="activeName3">
            <el-tab-pane label="政策法规" name="zcfg">
              <ul class="jlyd-ul">
             <li v-for="(zcfgdata,index) in zcfgdata1" :key="index">
               <span class="zcfg-span" @click="gonewstxt(zcfgdata.communicate_id)">{{zcfgdata.communicate_title}}</span><em>{{zcfgdata.create_time}}</em>
             </li>

              </ul>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <div class="ljwm">
        <h4>了解<span>我们</span></h4>
        <p class="p1" @click="gozzjg()"><img src="../../assets/images/ban1.jpg" alt=""></p>
        <p class="p11" @click="goqywh()"><img src="../../assets/images/ban2.jpg" alt=""></p>
        <p class="p11" @click="gorczp()"><img src="../../assets/images/ban3.jpg" alt=""></p>
      </div>
    </div>
    <div class="yqlj">
      <img src="../../assets/images/yqlj.png" alt="">
      <p>
        <span v-for="(yqljdatalist,index) in yqljdata" :key="index">
          <a :href="yqljdatalist.link_url">{{yqljdatalist.link_title}}</a>
        </span>
      </p>
    </div>

    <!--center END-->

    <!--footer-->
    <div class="bottom">
      <div class="bot-left">
        <p class="p1">联系广智华荣</p>
        <p>电子邮箱：406223221@qq.com</p>
        <p>总机：028-61894045</p>
        <p>公司地址：四川省成都市金牛区金周路595号 </p>
        <p>备案号：<a href="https://beian.miit.gov.cn/"  target="_blank" >蜀ICP备2021003450号11</a></p>
      </div>
      <div class="bot-right">
        <p class="p1"> 微信订阅号：</p>
        <p class="p2"><img src="../../assets/images/wm3.png" alt=""></p>
      </div>
    </div>
    <div class="footer">
      OPYRIGHT (©) 2022 四川广智华荣工程项目咨询有限公司 备案号：<a href="https://beian.miit.gov.cn/"    target="_blank" >蜀ICP备2021003450号</a>
    </div>
    <!--footer END-->



  </div>
</template>
<script>
  import http from '../../http.js'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        activeName: 'first',
        activeName2: 'negg',
        activeName3: 'zcfg',
        sign: "sign",
        timestamp: "timestamp",
        yqljdata: [],
        imgdata: [],
        newdata: "",
        newdata1: "",
        newdata2: "",
        newdata3: "",
        newdata4: "",
        biaodata1: "",
        biaodata2: "",
        biaodata3: "",
        zcfgdata1: "",
        indeximg: "",
      }
    },
    mounted: function() {
      this.getImages();
      this.getNewslist(1);
      this.getNewslist(2);
      this.getNewslist(3);
      this.getNewslist(4);
      this.getBiaolist(1);
      this.getBiaolist(2);
      this.getBiaolist(3);
      this.getBiaolist(4);
      this.getzcfglist(1);
      this.getyqlj();
      this.getindeximg();
    },
    methods: {

      //获取政策法规列表
      getzcfglist(i) {
        var that = this;
        var parameter = {
          sign: this.sign,
          timestamp: this.timestamp,
          type: i
        };
        http.post(this.conf.base_url + '/api/communicate/index', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {
            console.log(res.data.result);
           if (i == 1) {
             this.zcfgdata1 = res.data.result;
           }
          }
        }).catch(e => {
          //..
        })
      },


      //获取招标信息列表
      getBiaolist(i) {
        var that = this;
        var parameter = {
          sign: this.sign,
          timestamp: this.timestamp,
          type: i
        };
        http.post(this.conf.base_url + '/api/bidding/index', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {

            console.log(res.data.result);
           if (i == 1) {
             this.biaodata1 = res.data.result;
           }
           if (i == 2) {
             this.biaodata2 = res.data.result;
           }
           if (i == 3) {
             this.biaodata3 = res.data.result;
           }
          }
        }).catch(e => {
          //..
        })
      },


      //获取新闻列表
      getNewslist(i) {
        var that = this;
        var parameter = {
          sign: this.sign,
          timestamp: this.timestamp,
          type: i
        };
        http.post(this.conf.base_url + '/api/dynamic/index', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {

            console.log(res.data.result);
           if (i == 1) {
             this.newdata1 = res.data.result;
             this.newdata =res.data.result[0];
              console.log(11);
           }
           if (i == 2) {
             this.newdata2 = res.data.result;
                console.log(22);
           }
           if (i == 3) {
             this.newdata3 = res.data.result;
              console.log(33);
           }
           if (i == 4) {
             this.newdata4 = res.data.result;
                 console.log(44);
           }
          }
        }).catch(e => {
          //..
        })
      },

      //获取广告图
      getImages() {
        var that = this;
        var parameter = {
          sign: this.sign,
          timestamp: this.timestamp,
        }
        http.get(this.conf.base_url + '/api/adv/index', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {
            console.log(res.data.result);
            this.imgdata = res.data.result;
            console.log(33331);
            console.log(this.imgdata.adv_code);

          }
        }).catch(e => {
          //..
        })
      },

      //获取友情链接
      getyqlj() {
        var that = this;
        var parameter = {
          sign: this.sign,
          timestamp: this.timestamp,
        }
        http.get(this.conf.base_url + '/api/config/link', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {
             console.log(12312);
            console.log(res.data.result);
            this.yqljdata = res.data.result;
          }
        }).catch(e => {
          //..
        })
      },
       //获取首页图
      getindeximg() {
        var that = this;
        var parameter = {
          sign: this.sign,
          timestamp: this.timestamp,
        }
        http.get(this.conf.base_url + '/api/adv/first', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error('访问错误');
          } else {
            console.log(res.data.result);
            this.indeximg = res.data.result.pic;
            console.log(1111);
          console.log(indeximg);
          }
        }).catch(e => {
          //..
        })
      },


      //顶部导航链接
      goHome: function() {
        this.$router.push({
          path: '/index/'
        });
      },
      gogsdt: function() {
        this.$router.push({
          path: '/gsdt/'
        });
      },
      gojlyd: function() {
        this.$router.push({
          path: '/jlyd/'
        });
      },
      gokffw: function() {
        this.$router.push({
          path: '/kffw/'
        });
      },
      goqyjj: function() {
        this.$router.push({
          path: '/qyjj/'
        });
      },
      gorczp: function() {
        this.$router.push({
          path: '/rczp/'
        });
      },
      gozbxx: function() {
        this.$router.push({
          path: '/zbxx/'
        });
      },
      gobsxt: function() {
        this.$router.push({
          path: '/bsxt/'
        });
      },
      gonewstxt: function() {
        this.$router.push({
          path: '/newstxt/'
        });
      },

      gonewstxt:function (i) {
        this.$router.push({name:'newstxt', params: { id:i} } );
      },
      gozbxxtxt:function (i) {
        this.$router.push({name:'zbxxtxt', params: { id:i} } );
      },
      //内页跳转
      gogsdt:function () {
        this.$router.push({path:'/gsdt/'});
      },
      goqygg:function () {
        this.$router.push({path:'/qygg/'});
      },
      gozmt:function () {
        this.$router.push({path:'/zmt/'});
      },
      goshzr:function () {
        this.$router.push({path:'/shzr/'});
      },
      gojggg:function () {
       this.$router.push({path:'/jggg/'});
      },
      gogzgg:function () {
        this.$router.push({path:'/gzgg/'});
      },
     goqywh:function () {
        this.$router.push({path:'/qywh/'});
      },
      gofzjg:function () {
        this.$router.push({path:'/fzjg/'});
      },
      gofzjg:function () {
        this.$router.push({path:'/fzjg/'});
      },
      gorygs:function () {
        this.$router.push({path:'/rygs/'});
      },
      gozzjg:function () {
        this.$router.push({path:'/zzjg/'});
      },

      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleClick2(tab, event) {
        console.log(tab, event);
      },
      handleClick3(tab, event) {
        console.log(tab, event);
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/index.vue